import { render, staticRenderFns } from "./SkillCategories.vue?vue&type=template&id=34a4295a&"
import script from "./SkillCategories.vue?vue&type=script&lang=js&"
export * from "./SkillCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports